<template>
    <div class="row align-items-center mt-6" v-loading="loading">
        <div class="col-sm-12 col-md-12">
            <el-form ref="formAcademic" :model="formAcademic" status-icon :rules="rules" label-position="left">
                <div class="row mb-8" v-if="!modalEdit">
                    <div class="col-sm-7">
                        <div class="d-flex align-items-center">
                            <span class="label label-success label-inline mr-2" style="font-size: 1rem;">Deportista</span>
                            <h3 class="text-dark font-weight-bold mb-0">{{currentAcreditation.athlete}}</h3>
                        </div>
                    </div>
                    <div class="col-sm-5 d-none">
                        <div class="d-flex align-items-center">
                            <span class="label label-primary label-inline mr-2" style="font-size: 1rem;">Disciplina</span>
                            <h3 class="text-dark font-weight-bold mb-0">Taekwondo</h3>
                        </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-5">
                        <el-form-item label="Formación Deportiva" label-width="160px" prop="straining">
                            <el-select v-model="formAcademic.straining" placeholder="Seleccionar" size="small" class="w-100">
                            <el-option v-for="item in listSportTrainig" :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="col-sm-4">
                        <el-form-item label="Condición" label-width="100px" prop="acondition">
                            <el-select v-model="formAcademic.acondition" placeholder="Seleccionar" size="small" class="w-100">
                            <el-option v-for="item in listAcademicCondition" :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="col-sm-3" v-if="formAcademic.acondition == 'E'">
                        <el-form-item label="Periodo" label-width="80px" prop="periodo">
                            <el-select v-model="formAcademic.periodo"   placeholder="Seleccionar" size="small" class="w-100">
                            <el-option :key="getYear" :label="getYear" :value="getYear"></el-option>
                            <el-option :key="getYear-1" :label="getYear-1" :value="getYear-1"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-3">
                        <el-form-item label="Código de alumno" class="mb-3" prop="studentcode">
                            <el-input v-model="formAcademic.studentcode" size="small" maxlength="50"></el-input>          
                        </el-form-item>
                    </div>
                    <div class="col-sm-3">
                        <el-form-item label="Tipo de matrícula" class="mb-3" prop="tmatricule">
                            <el-select v-model="formAcademic.tmatricule" placeholder="Seleccionar" size="small" class="w-100">
                            <el-option v-for="item in listTypeMatricule" :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="col-sm-3" v-if="formAcademic.acondition == 'P'">
                        <el-form-item label="Ciclo" class="mb-3" prop="cycle">
                            <el-select v-model="formAcademic.cycle" placeholder="Seleccionar" size="small" class="w-100">
                            <el-option v-for="item in listCycle" :key="item.id" :label="item.name" :value="item.id"></el-option>
                            </el-select>
                        </el-form-item>
                    </div>
                    <div class="col-sm-3">
                        <el-form-item label="# Créditos" class="mb-3" prop="credits">
                            <el-input v-model="formAcademic.credits" size="small" maxlength="2"></el-input>
                        </el-form-item>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-6">
                        <el-form-item label="Facultad" prop="faculty">
                            <el-input v-model="formAcademic.faculty" size="small" maxlength="50"></el-input>          
                        </el-form-item>
                    </div>
                    <div class="col-sm-6">
                        <el-form-item label="Especialidad" prop="specialty">
                            <el-input v-model="formAcademic.specialty" size="small" maxlength="50"></el-input>
                        </el-form-item>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-4">
                        <el-form-item label="Peso" label-width="60px" prop="peso">
                            <el-input type="peso" v-model="formAcademic.peso" size="small" maxlength="3">
                            <template #append>Kg</template>
                            </el-input>
                        </el-form-item>
                    </div>
                    <div class="col-sm-4">
                        <el-form-item label="Talla" label-width="60px" prop="talla">
                            <el-input type="talla" v-model="formAcademic.talla" size="small" maxlength="3">
                                <template #append>cm</template>
                            </el-input>
                        </el-form-item>
                    </div>
                </div>

            </el-form>
            <el-divider class="my-4"></el-divider>
            <div class="d-flex justify-content-end" v-if="modalEdit">
                <div class="btn btn-sm btn btn-light mr-3" @click="cancelEdit"><i class="el-icon-close"></i>Cerrar</div>
                <div class="btn btn-sm btn-success" @click="updateAcademic('formAcademic')">Actualizar <i class="el-icon-edit-outline pr-0"></i></div>
            </div>
            <div class="d-flex justify-content-end" v-else>
                <div class="btn btn-sm btn-secondary mr-3" @click="cancelProcess"><i class="el-icon-close"></i> Cancelar</div>
                <div class="btn btn-sm btn-success"  @click="submitAcademic('formAcademic')">Siguiente <i class="el-icon-arrow-right pr-0"></i></div>
            </div>
        </div>
    </div>
</template>

<script>
import dataJson from "@/data/common";
import { mapGetters } from "vuex";

//stores
import { STEP, MODAL_NEW, MODAL_EDIT } from "@/store/step.module";
import { REGISTER_ACADEMIC, UPDATE_ACADEMIC } from "@/store/acreditation.module";

export default {
  props: {
    academicdata: {
      type: Object,
      default: () => {}
    },
  },
  data(){
    return{
      loading: false,
      getYear: null,
      listSportTrainig: dataJson.sportsTraining,
      listAcademicCondition: dataJson.academicCondition,
      listTypeMatricule: dataJson.typeMatricule,
      listCycle: dataJson.cycle,
      formAcademic:{
        straining: null,
        acondition: null,
        tmatricule: null,
        studentcode: null,
        cycle: null,
        periodo: null,
        credits: null,
        faculty: null,
        specialty: null,
        peso: null,
        talla: null
      },
      rules: {
        straining: [{required: true,message: 'Seleccione formación deportiva',trigger: ['change', 'blur']}],
        acondition: [{required: true,message: 'Seleccione condición',trigger: ['change', 'blur']}],
        periodo: [
          {required: true, message: 'Seleccione año', trigger: ['change', 'blur']}
        ],
        studentcode: [{required: true, message: 'Ingrese código alumno',trigger: 'blur'}],
        tmatricule: [{required: true,message: 'Seleccione tipo matricula',trigger: ['change', 'blur']}],
        cycle: [{required: true,message: 'Seleccione # ciclo',trigger: ['change', 'blur']}],
        credits: [
          {required: true, message: 'Ingrese # de creditos'},
          {min:1, max:2, message: 'Créditos debe ser numerico'}
        ],
        faculty: [
          {required: true, message: 'Ingrese facultad', trigger: 'blur'}
        ],
        specialty: [
          {required: true, message: 'Ingrese especialidad', trigger: 'blur'}
        ],
        peso: [
          {required: true, message: 'Peso del deportista'},
          {min:1, max:3, message: 'Peso debe ser numerico'}
        ],
        talla: [
          {required: true, message: 'Talla del deportista'},
          {min:1, max:3, message: 'Talla debe ser numerico'}
        ]
      }
    }
  },
  computed: {
    ...mapGetters([
      "currentAcreditation", "modalEdit"
    ])
  },
  beforeMount(){
    if(this.modalEdit){
      return this.formAcademic = this.academicdata;
      
    } 
  },
  methods:{
    submitAcademic(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          try {
            this.loading = true;
            this.$store.dispatch(REGISTER_ACADEMIC, {"acrd": this.currentAcreditation, "academic": this.formAcademic})
            .then(() => {
                this.$store.dispatch(STEP, 3).then(()=>{
                  this.loading = false;
                });
            })
            .catch((err) => {
              this.loading = false;
              this.$alert( err.data !='' ? err.data.messages.error : err.statusText, 'Lo sentimos, error: ' + err.status, {
                type: 'error',
                confirmButtonText: 'Entendido',
                callback: action => {
                  if(err.status == 401)
                    this.$router.push({ name: "login" });
                }
              });
            });
          }catch (error) {
            this.loading = false;
            this.$notify.error({title: 'Error:', message: error});
          }
        }else {
          return false;
        }
      });
    },
    updateAcademic(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          try {
            this.loading = true;
            this.$store.dispatch(UPDATE_ACADEMIC, {slug: this.academicdata.idacreditation, data: this.formAcademic})
            .then((data) => {
                this.loading = false;
                this.$notify.success({title: 'Perefcto', message: 'Datos académicos actualizados correctamente.'});
            })
            .catch((err) => {
              this.loading = false;
              this.$alert( err.data !='' ? err.data.messages.error : err.statusText, 'Lo sentimos, error: ' + err.status, {
                type: 'error',
                confirmButtonText: 'Entendido',
                callback: action => {
                  if(err.status == 401)
                    this.$router.push({ name: "login" });
                }
              });
            });
          }catch (error){
            this.loading = false;
            this.$notify.error({title: 'Error:', message: error});
          }
        }
      });
    },
    cancelProcess(){
        this.$store.dispatch(MODAL_NEW, false);
    },
    cancelEdit(){
        this.$store.dispatch(MODAL_EDIT, false);
    }
  },
  created(){
    var fecha = new Date();
    this.getYear = fecha.getFullYear();
  }
}
</script>